import { render, staticRenderFns } from "./CustomExport.vue?vue&type=template&id=e4959738&scoped=true&"
import script from "./CustomExport.vue?vue&type=script&lang=js&"
export * from "./CustomExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4959738",
  null
  
)

export default component.exports